module.exports = __webpack_public_path__ + "elements/footer/hkt-logo-2x.png?ver=cd3d0436";